import type { UserSettingsModalTab } from 'ComponentLibrary/src/molecules/UserSettings/types'

export const USER_SETTINGS_SEARCH_PARAM = 'settings'

export function parseUserSettingsModalTab(value: string | null): UserSettingsModalTab | undefined {
    if (value === 'profile' || value === 'notifications') {
        return value
    }
    return undefined
}

export function getUserSettingsModalSearch(search: string | URLSearchParams, tab: UserSettingsModalTab) {
    const searchParams = new URLSearchParams(search)
    searchParams.set(USER_SETTINGS_SEARCH_PARAM, tab)
    return `?${searchParams.toString()}`
}

export function removeUserSettingsModalSearch(search: string | URLSearchParams) {
    const searchParams = new URLSearchParams(search)
    searchParams.delete(USER_SETTINGS_SEARCH_PARAM)
    const nextSearch = searchParams.toString()
    return nextSearch ? `?${nextSearch}` : ''
}

export function getUserSettingsModalUrl({
    pathname,
    search,
    hash,
    tab,
}: {
    pathname: string
    search: string | URLSearchParams
    hash?: string
    tab: UserSettingsModalTab
}) {
    return `${pathname}${getUserSettingsModalSearch(search, tab)}${hash ?? ''}`
}
